/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

const PracticeApi = {
  public: {},
  private: {
    /**
     *  To fetch all practices the user has access to
     */
    fetchAllUserPractices: () => ProtectedHttpClient.get(`/user/practices`),
    /**
     *  To fetch all facilities of a specific practice
     */
    fetchAllFacilitiesByPracticeId: (practiceId) => ProtectedHttpClient.get(`/facilities/${practiceId}`)

  },
};
export default PracticeApi;
